"use strict";
/*
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the
 * License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Url = require("url");

var errors_1 = require("../errors");

var logger_1 = require("../logger");

var xhr_1 = require("../xhr");

var https = require('follow-redirects').https;

var http = require('follow-redirects').http;
/**
 * A Node.js HTTP client.
 */


var NodeRequestor =
/** @class */
function (_super) {
  __extends(NodeRequestor, _super);

  function NodeRequestor() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  NodeRequestor.prototype.xhr = function (settings) {
    return new Promise(function (resolve, reject) {
      // implementing a subset that is required.
      var url = Url.parse(settings.url);
      var data = settings.data;
      var options = {
        hostname: url.hostname,
        port: url.port,
        path: url.path,
        method: settings.method,
        headers: settings.headers || {}
      };

      if (data) {
        options.headers['Content-Length'] = String(data.toString().length);
      }

      var protocol = https;

      if (url.protocol && url.protocol.toLowerCase() === 'http:') {
        protocol = http;
      }

      var request = protocol.request(options, function (response) {
        if (response.statusCode !== 200) {
          logger_1.log('Request ended with an error ', response.statusCode);
          reject(new errors_1.AppAuthError(response.statusMessage));
        }

        var chunks = [];
        response.on('data', function (chunk) {
          chunks.push(chunk.toString());
        });
        response.on('end', function () {
          var body = chunks.join('');

          if (settings.dataType === 'json') {
            try {
              resolve(JSON.parse(body));
            } catch (err) {
              logger_1.log('Could not parse json response', body);
            }
          } else {
            resolve(body);
          }
        });
      });
      request.on('error', function (e) {
        reject(new errors_1.AppAuthError(e.toString()));
      });

      if (data) {
        request.write(data);
      }

      request.end();
    });
  };

  return NodeRequestor;
}(xhr_1.Requestor);

exports.NodeRequestor = NodeRequestor;